module.exports = __webpack_public_path__ + "b0edd345a1fbc24042213b923f6eedd1.svg";